export const Categories = {
  top_100: {
    name: 'Top 100 Words',
    id: 'top_100',
    korean: 'Top 100 Words',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'A thing or an object', k: '것' },
      { e: 'To do', k: '하다' },
      { e: 'To have', k: '있다' },
      { e: 'To become / To be', k: '되다' },
      { e: 'Number', k: '수' },
      { e: 'I, me', k: '나' },
      { e: 'He, That', k: '그' },
      { e: 'Do not exist, none', k: '없다' },
      { e: 'To not be', k: '않다' },
      { e: 'Person', k: '사람' },
      { e: 'We, our', k: '우리' },
      { e: 'This', k: '이' },
      { e: 'To not be', k: '아니다' },
      { e: 'To see', k: '보다' },
      { e: 'Etc.', k: '등' },
      { e: 'At the time / Time', k: '때' },
      { e: 'Thing', k: '거' },
      { e: 'To be similar', k: '같다' },
      { e: 'To give', k: '주다' },
      { e: 'To treat, to face', k: '대하다' },
      { e: 'To go', k: '가다' },
      { e: 'Year', k: '년' },
      { e: 'One, a single', k: '한' },
      { e: 'Word, speech', k: '말' },
      { e: 'Work / Day', k: '일' },
      { e: 'Subject particle', k: '이' },
      { e: 'Because', k: '때문' },
      { e: 'To speak', k: '말하다' },
      { e: 'To do for the sake of', k: '위하다' },
      { e: 'But', k: '그러나' },
      { e: 'To know', k: '알다' },
      { e: 'Mr. / Seed', k: '씨' },
      { e: 'To be right / Yes', k: '그렇다' },
      { e: 'To be big / Large', k: '크다' },
      { e: 'In addition / Again', k: '또' },
      { e: 'Social / Society', k: '사회' },
      { e: 'Many', k: '많다' },
      { e: 'Not / Within', k: '안' },
      { e: 'To be good', k: '좋다' },
      { e: 'More', k: '더' },
      { e: 'To receive', k: '받다' },
      { e: 'That (thing)', k: '그것' },
      { e: 'House', k: '집' },
      { e: 'To come out', k: '나오다' },
      { e: 'To follow', k: '따르다' },
      { e: 'And', k: '그리고' },
      { e: 'Problem / Question', k: '문제' },
      { e: 'Then', k: '그런' },
      { e: 'To live', k: '살다' },
      { e: 'I / Self / That', k: '저' },
      { e: 'Cannot do', k: '못하다' },
      { e: 'To think', k: '생각하다' },
      { e: 'To not know', k: '모르다' },
      { e: 'Inside', k: '속' },
      { e: 'To make', k: '만들다' },
      { e: 'Place / Point', k: '데' },
      { e: 'Two / Couple', k: '두' },
      { e: 'In front of', k: '앞' },
      { e: 'Case / Instance', k: '경우' },
      { e: 'Centre / Middle', k: '중' },
      { e: 'Which / What kind of', k: '어떤' },
      { e: 'Well', k: '잘' },
      { e: 'She', k: '그녀' },
      { e: 'To eat', k: '먹다' },
      { e: 'To come', k: '오다' },
      { e: 'Oneself / Myself', k: '자신' },
      { e: 'Culture', k: '문화' },
      { e: 'Korean Won', k: '원' },
      { e: 'Thought', k: '생각' },
      { e: 'How', k: '어떻다' },
      { e: 'Person counter', k: '명' },
      { e: 'To pass / To run / Go through', k: '통하다' },
      { e: 'Then / And so', k: '그러다' },
      { e: 'Sound', k: '소리' },
      { e: 'Again', k: '다시' },
      { e: 'Different', k: '다른' },
      { e: 'This', k: '이런' },
      { e: 'Woman', k: '여자' },
      { e: 'Dog / Piece', k: '개' },
      { e: 'Degree', k: '정도' },
      { e: 'Back / End', k: '뒤' },
      { e: 'To listen / To hear', k: '듣다' },
      { e: 'All / Everything', k: '다' },
      { e: 'A little', k: '좀' },
      { e: 'To hold', k: '들다' },
      { e: 'To want, hope', k: '싶다' },
      { e: 'To show', k: '보이다' },
      { e: 'To have / To take', k: '가지다' },
      { e: 'Together', k: '함께' },
      { e: 'Child', k: '아이' },
      { e: 'To pass by / To go past', k: '지나다' },
      { e: 'A lot', k: '많이' },
      { e: 'Time', k: '시간' },
      { e: 'You', k: '너' },
      { e: 'Person / Human being', k: '인간' },
      { e: 'Actually / Reality', k: '사실' },
      { e: 'To emanate / To break out', k: '나다' },
      { e: 'a	Like this', k: '이렇다' },
    ],
  },
  conjunctions: {
    name: 'Conjunctions',
    id: 'conjunctions',
    korean: '접속사',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'but', k: '그렇지만' },
      { e: 'however', k: '아무리' },
      { e: 'following', k: '이어서' },
      { e: 'because', k: '때문에' },
      { e: 'but, however, by the way', k: '그런데' },
      { e: 'but, still', k: '그래도' },
      { e: 'but, however', k: '하지만' },
      { e: 'so, therefore', k: '그래서' },
      { e: 'and', k: '그리고' },
    ],
  },
  verbs: {
    name: 'Essential Verbs',
    id: 'verbs',
    korean: '동사',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'To answer', k: '대답하다' },
      { e: 'To arrive', k: '도착하다' },
      { e: 'To ask', k: '묻다, 물어보다' },
      { e: 'To be born', k: '태어나다' },
      { e: 'To be sorry', k: '죄송하다' },
      { e: 'To boil', k: '끓이다' },
      { e: 'To borrow, to lend', k: '빌리다' },
      { e: 'To buy', k: '사다' },
      { e: 'To chop, to slice', k: '썰다' },
      { e: 'To clean', k: '청소하다' },
      { e: 'To close', k: '닫다' },
      { e: 'To come', k: '오다' },
      { e: 'To confess', k: '고백하다' },
      { e: 'To congratulate', k: '축하하다' },
      { e: 'To cook', k: '요리하다' },
      { e: 'To cry', k: '울다' },
      { e: 'To dance', k: '춤추다' },
      { e: 'To deep fry', k: '튀기다' },
      { e: 'To depart', k: '출발하다' },
      { e: 'To die', k: '죽다' },
      { e: 'To do', k: '하다' },
      { e: 'To dream', k: '꿈꾸다' },
      { e: 'To drink', k: '마시다' },
      { e: 'To drive', k: '운전하다' },
      { e: 'To eat', k: '먹다' },
      { e: 'To enter', k: '들어오다' },
      { e: 'To exercise', k: '운동하다' },
      { e: 'To exit', k: '나가다' },
      { e: 'To flight', k: '싸우다' },
    ],
  },
  continents: {
    name: 'Continents',
    id: 'continents',
    korean: '대륙',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Europe', k: '유럽' },
      { e: 'Asia', k: '아시아' },
      { e: 'North America', k: '남아메리카' },
      { e: 'South  America', k: '북아메리카' },
      { e: 'Africa', k: '아프리카' },
      { e: 'Oceania', k: '오세아니아' },
      { e: 'Antartica', k: '남국' },
      { e: 'Earth', k: '지구' },
      { e: 'Continent', k: '대륙' },
    ],
  },
  months: {
    name: 'Months',
    id: 'months',
    korean: '달',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'January', k: '일월' },
      { e: 'February', k: '이월' },
      { e: 'March', k: '삼월' },
      { e: 'April', k: '사월' },
      { e: 'May', k: '오월' },
      { e: 'June', k: '유월' },
      { e: 'July', k: '칠월' },
      { e: 'August', k: '팔월' },
      { e: 'September', k: '구월' },
      { e: 'October', k: '시월' },
      { e: 'November', k: '십일월' },
      { e: 'December', k: '십이월' },
      { e: 'Month', k: '달' },
      { e: 'Month Counter', k: '월' },
      { e: 'Last Month', k: '지난달' },
      { e: 'Next Month', k: '다음 달' },
    ],
  },
  time: {
    name: 'Time',
    id: 'time',
    korean: '시간',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'This week', k: '이번 주에' },
      { e: 'This (Week/Month)', k: '이번' },
      { e: 'Next', k: '다음' },
      { e: 'Last Week', k: '지난 주에' },
      { e: 'Last', k: '지난' },
      { e: 'Next year', k: '내년' },
      { e: 'Last year', k: '작년' },
      { e: 'Year', k: '년' },
      { e: 'Month', k: '달' },
      { e: 'Week / Week Counter', k: '주' },
      { e: 'Day Counter', k: '일' },
      { e: 'Day', k: '날' },
      { e: 'For 2 minutes', k: '이분 동안' },
      { e: 'For an amount of time', k: '동안' },
      { e: 'Time', k: '시간' },
      { e: "Three o'clock", k: '세 시' },
      { e: 'Hour', k: '시간' },
      { e: '2 minutes', k: '이분' },
      { e: 'Minute', k: '분' },
      { e: '2 Seconds', k: '이초' },
      { e: 'Second', k: '초' },
    ],
  },
  seasons: {
    name: 'Seasons',
    id: 'seasons',
    korean: '계절',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Winter', k: '겨울' },
      { e: 'Fall/Autumn', k: '가을' },
      { e: 'Summer', k: '여름' },
      { e: 'Spring', k: '봄' },
      { e: 'Season', k: '계절' },
    ],
  },
  weather: {
    name: 'Weather',
    id: 'weather',
    korean: '날씨',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Blizzard', k: '눈바람' },
      { e: 'Climate', k: '기후' },
      { e: 'Clouds', k: '구름' },
      { e: 'Drought', k: '가뭄' },
      { e: 'Earthquake', k: '지진' },
      { e: 'Flood', k: '홍수' },
      { e: 'Fog', k: '안개' },
      { e: 'Hail', k: '우박' },
      { e: 'Heat Wave', k: '폭염' },
      { e: 'Ice', k: '얼음' },
      { e: 'Lightning', k: '번개' },
      { e: 'Rain', k: '비' },
      { e: 'Sky', k: '하늘' },
      { e: 'Snow', k: '눈' },
      { e: 'Snowflake', k: '눈송이' },
      { e: 'Storm', k: '폭풍' },
      { e: 'Sun', k: '해' },
      { e: 'Temperature', k: '기온' },
      { e: 'Thunder', k: '천둥' },
      { e: 'To be chilly', k: '쌀쌀하다' },
      { e: 'To be clear', k: '맑다' },
      { e: 'To be cold', k: '춥다' },
      { e: 'To be cool', k: '서늘하다' },
      { e: 'To be dry', k: '건조하다' },
      { e: 'To be hot', k: '덥다' },
      { e: 'To be humid', k: '습하다' },
      { e: 'To be warm', k: '따뜻하다' },
      { e: 'Typhoon', k: '태풍' },
      { e: 'Weather', k: '날씨' },
      { e: 'Wind', k: '바람' },
    ],
  },
  buildings: {
    name: 'Buildings',
    id: 'buildings',
    korean: '건물',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Airport', k: '공항' },
      { e: 'Apartment', k: '아파트' },
      { e: 'Art Gallery', k: '미술관' },
      { e: 'Bakery', k: '제과점' },
      { e: 'Bank', k: '은행' },
      { e: 'Barbershop', k: '이발소' },
      { e: 'Bathhouse', k: '목욕탕' },
      { e: 'Beauty Salon', k: '미장원' },
      { e: 'Bookstore', k: '서점' },
      { e: 'Building', k: '건물' },
      { e: 'Bus Stop', k: '버스정류소' },
      { e: 'City Hall', k: '시청' },
      { e: 'Convenience Store', k: '편의점' },
      { e: 'Court of Law', k: '법원' },
      { e: 'Cyber Cafe', k: 'PC방' },
      { e: 'Department Store', k: '백화점' },
      { e: 'Discount Store', k: '할인점' },
      { e: 'District Office', k: '구청' },
      { e: 'Duty-free Shop', k: '면세점' },
      { e: 'Elementary School', k: '초등학교' },
      { e: 'Fire Station', k: '소방서' },
      { e: 'Furniture Store', k: '가구점' },
      { e: 'Gas Station', k: '주유소' },
      { e: 'High School', k: '고등학교' },
      { e: 'Hospital', k: '병원' },
      { e: 'Hotel', k: '호텔' },
      { e: 'Motel', k: '모텔' },
      { e: 'Inn', k: '여관' },
      { e: 'Laundromat / Launderette', k: '세탁소' },
      { e: 'Middle School', k: '중학교' },
      { e: 'Movie Theater', k: '영화관' },
      { e: 'Museum', k: '박물관' },
      { e: 'Orphanage', k: '고아원' },
      { e: 'Park', k: '공원' },
      { e: 'Pharmacy', k: '약국' },
      { e: 'Playground', k: '놀이터' },
      { e: 'Police Station', k: '경찰서' },
      { e: 'Port', k: '항구' },
      { e: 'Post Office', k: '우체국' },
      { e: 'Preschool', k: '유치원' },
      { e: 'Prison', k: '교도소' },
      { e: 'Bar / Pub', k: '술집' },
      { e: 'Restaurant', k: '식당 / 음식점' },
      { e: 'Store', k: '가게' },
      { e: 'Subway Station', k: '전철역(지하철역)' },
      { e: 'Supermarket', k: '슈퍼' },
      { e: 'Swimming Pool', k: '수영장' },
      { e: 'Theater', k: '극장' },
      { e: 'Train Station', k: '기차역' },
      { e: 'University', k: '대학교' },
    ],
  },
  furniture: {
    name: 'Furniture',
    id: 'furniture',
    korean: '가구',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Bed', k: '침대' },
      { e: 'Bookshelf', k: '책장' },
      { e: 'Chair', k: '의자' },
      { e: 'Coffee Table', k: '탁자' },
      { e: 'Counter', k: '싱크대' },
      { e: 'Desk', k: '책상' },
      { e: 'Drawer', k: '서랍' },
      { e: 'Dresser', k: '서랍장' },
      { e: 'Footrest', k: '발판' },
      { e: 'Nightstand', k: '침실용 탁자' },
      { e: 'Sofa', k: '소파' },
      { e: 'Table', k: '식탁' },
    ],
  },
  counter_words: {
    name: 'Counter Words',
    id: 'counter_words',
    korean: '수분류사',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
      { id: 'n', name: 'Number System' },
    ],
    words: [
      { e: 'Age, Years old', k: '살', n: 'Native' },
      { e: 'A house number', k: '번지', n: 'Sino Korean' },
      { e: 'Animals', k: '마리', n: 'Native' },
      { e: 'Books, Volumes', k: '권', n: 'Native' },
      { e: 'Bottles', k: '병', n: 'Native' },
      { e: 'Bowls', k: '그릇', n: 'Native' },
      { e: 'Box', k: '상자', n: 'Native' },
      { e: 'Bunch', k: '송이', n: 'Native' },
      { e: 'Class Periods', k: '교시', n: 'Sino Korean' },
      { e: 'Clothes', k: '벌', n: 'Native' },
      { e: 'Couple', k: '쌍', n: 'Native' },
      { e: 'Cups, Glasses', k: '잔', n: 'Native' },
      { e: 'Days', k: '일', n: 'Sino Korean' },
      { e: 'Episode', k: '회', n: 'Sino Korean' },
      { e: 'Flat objects, Paper, Sheets, Leaves', k: '장', n: 'Native' },
      { e: 'Floor', k: '층', n: 'Sino Korean' },
      { e: 'Hours', k: '시간', n: 'Native' },
      { e: 'Kinds, Varieties', k: '가지', n: 'Native' },
      { e: 'Lines, things aligned in a row', k: '줄', n: 'Native' },
      { e: 'Minutes', k: '분', n: 'Sino Korean' },
      { e: 'Month Identifier', k: '월', n: 'Sino Korean' },
      { e: 'Months', k: '개월', n: 'Sino Korean' },
      { e: 'Months', k: '달', n: 'Native' },
      { e: 'Number', k: '번', n: 'Sino Korean' },
      { e: "O'clock", k: '시', n: 'Native' },
      { e: 'Packs of cigarettes', k: '갑', n: 'Native' },
      { e: 'Packs, Sacks', k: '봉지', n: 'Native' },
      { e: 'People (Formal)', k: '분', n: 'Native' },
      { e: 'People (Informal)', k: '명, 사람', n: 'Native' },
      { e: 'Pieces', k: '조각', n: 'Native' },
      { e: 'Plates', k: '접시', n: 'Native' },
      { e: 'Room number', k: '호', n: 'Sino Korean' },
      { e: 'Seconds', k: '초', n: 'Sino Korean' },
      { e: 'Servings', k: '인분', n: 'Sino Korean' },
      { e: 'Shoes, Socks', k: '켤레', n: 'Native' },
      { e: 'Stick like items', k: '자루', n: 'Native' },
      { e: 'Temperature Degrees', k: '도', n: 'Sino Korean' },
      { e: 'Things, General Counter', k: '개', n: 'Native' },
      { e: 'Time', k: '번', n: 'Native' },
      { e: 'Trees', k: '그루', n: 'Native' },
      { e: 'Vehicles, Machinery', k: '대', n: 'Native' },
      { e: 'Weeks', k: '주일', n: 'Sino Korean' },
      { e: 'Won (currency)', k: '원', n: 'Sino Korean' },
      { e: 'Years', k: '년', n: 'Sino Korean' },
    ],
  },
  transportation: {
    name: 'Transportation',
    id: 'transportation',
    korean: '교통 수단',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Airplane', k: '비행기' },
      { e: 'Bike/Bicycle', k: '자전거' },
      { e: 'Boat', k: '보트' },
      { e: 'Bus', k: '버스' },
      { e: 'Bus stop', k: '정류장' },
      { e: 'Car', k: '차' },
      { e: 'Delivery van', k: '배달차' },
      { e: 'Gas stop', k: '주유소' },
      { e: 'Hood', k: '덮개' },
      { e: 'License Plate', k: '차량 번호판' },
      { e: 'Moped', k: '모터 자전기' },
      { e: 'Motor', k: '모터' },
      { e: 'Motorbike', k: '오토바이' },
      { e: 'Parking lot', k: '주차장' },
      { e: 'Police car', k: '순찰차' },
      { e: 'Subway', k: '지하철' },
      { e: 'Taxi', k: '택시' },
      { e: 'Tire', k: '타이어' },
      { e: 'Truck', k: '트럭, 화물차' },
      { e: 'Trunk', k: '트렁크' },
      { e: 'Van', k: '승합차' },
      { e: 'Wheel', k: '바퀴' },
      { e: 'Windshield', k: '앞유리' },
    ],
  },
  sino_korean_numbers: {
    name: 'Sino Numbers',
    id: 'sino_korean_numbers',
    korean: '숫자',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: '0', k: '영, 령, 공' },
      { e: '1', k: '일' },
      { e: '2', k: '이' },
      { e: '3', k: '삼' },
      { e: '4', k: '사' },
      { e: '5', k: '오' },
      { e: '6', k: '육' },
      { e: '7', k: '칠' },
      { e: '8', k: '팔' },
      { e: '9', k: '구' },
      { e: '10', k: '십' },
      { e: '11', k: '십일' },
      { e: '12', k: '십이' },
      { e: '13', k: '십삼' },
      { e: '14', k: '십사' },
      { e: '15', k: '십오' },
      { e: '16', k: '십육' },
      { e: '17', k: '십칠' },
      { e: '18', k: '십팔' },
      { e: '19', k: '십구' },
      { e: '20', k: '이십' },
      { e: '30', k: '삼십' },
      { e: '40', k: '사십' },
      { e: '50', k: '오십' },
      { e: '60', k: '육십' },
      { e: '70', k: '칠십' },
      { e: '80', k: '팔십' },
      { e: '90', k: '구십' },
      { e: '100', k: '백' },
      { e: '1000', k: '천' },
      { e: '10000', k: '만' },
      { e: '100000000', k: '억' },
    ],
  },
  native_korean_numbers: {
    name: 'Native Numbers',
    id: 'native_korean_numbers',
    korean: '한국어 숫자',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: '1', k: '하나' },
      { e: '2', k: '둘' },
      { e: '3', k: '셋' },
      { e: '4', k: '넷' },
      { e: '5', k: '다섯' },
      { e: '6', k: '여섯' },
      { e: '7', k: '일곱' },
      { e: '8', k: '여덟' },
      { e: '9', k: '아홉' },
      { e: '10', k: '열' },
      { e: '11', k: '열하나' },
      { e: '12', k: '열둘' },
      { e: '13', k: '열셋' },
      { e: '14', k: '열넷' },
      { e: '15', k: '열다섯' },
      { e: '16', k: '열여섯' },
      { e: '17', k: '열일곱' },
      { e: '18', k: '열여덟' },
      { e: '19', k: '열아홉' },
      { e: '20', k: '스물' },
      { e: '30', k: '서른' },
      { e: '40', k: '마흔' },
      { e: '50', k: '쉰' },
      { e: '60', k: '예순' },
      { e: '70', k: '일흔' },
      { e: '80', k: '여든' },
      { e: '90', k: '아흔' },
    ],
  },
  directions: {
    name: 'Directions',
    id: 'directions',
    korean: '방향',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'North', k: '북쪽' },
      { e: 'West', k: '서쪽' },
      { e: 'South', k: '남쪽' },
      { e: 'East', k: '동쪽' },
      { e: 'Left', k: '왼쪽' },
      { e: 'Right', k: '오른쪽' },
      { e: 'Front', k: '앞' },
      { e: 'Back', k: '뒤' },
      { e: 'Above', k: '위에' },
      { e: 'Below', k: '아래에' },
    ],
  },
  days_of_the_week: {
    name: 'Days of the Week',
    id: 'days_of_the_week',
    korean: '날',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Monday', k: '월요일' },
      { e: 'Tuesday', k: '화요일' },
      { e: 'Wednesday', k: '수요일' },
      { e: 'Thursday', k: '목요일' },
      { e: 'Friday', k: '금요일' },
      { e: 'Saturday', k: '토요일' },
      { e: 'Sunday', k: '일요일' },
    ],
  },
  jobs: {
    name: 'Jobs',
    id: 'jobs',
    korean: '직업',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Accountant', k: '회계사' },
      { e: 'Actor', k: '남자배우' },
      { e: 'Actress', k: '여자배우' },
      { e: 'Anthropologist', k: '인류학자' },
      { e: 'Archaeologist', k: '고고학자' },
      { e: 'Architect', k: '건축가' },
      { e: 'Artist', k: '미술가' },
      { e: 'Athlete', k: '선수' },
      { e: 'Baker', k: '제빵사' },
      { e: 'Barber', k: '이용사' },
      { e: 'Boss', k: '사장님' },
      { e: 'Carpenter', k: '목수' },
      { e: 'Chef', k: '주방장' },
      { e: 'Civil Engineer', k: '토목기사' },
      { e: 'Cleaner', k: '청소부' },
      { e: 'Clerk', k: '점원' },
      { e: 'Coach', k: '코치' },
      { e: 'Delivery man', k: '배달원' },
      { e: 'Detective', k: '형사' },
      { e: 'Doctor', k: '의사' },
      { e: 'Driver', k: '운전수' },
      { e: 'Electrician', k: '전기공' },
      { e: 'Engineer', k: '기관사' },
      { e: 'Farmer', k: '농부' },
      { e: 'Fire Fighter', k: '소방사' },
      { e: 'Fisher', k: '어부' },
      { e: 'Gardener', k: '원예사' },
      { e: 'Government Employee', k: '공무원' },
      { e: 'Guard', k: '경비원' },
      { e: 'Hairdresser', k: '미용사' },
      { e: 'Housewife', k: '주부' },
      { e: 'Judge', k: '판사' },
      { e: 'Lawyer', k: '변호사' },
      { e: 'Librarian', k: '사서' },
      { e: 'Mailman', k: '우체부' },
      { e: 'Miner', k: '광부' },
      { e: 'Model', k: '모델' },
      { e: 'Nurse', k: '간호사' },
      { e: 'Office Worker', k: '회사원' },
      { e: 'Painter', k: '화가' },
      { e: 'Photographer', k: '조종사' },
      { e: 'Physicist', k: '물리학자' },
      { e: 'Pilot', k: '조종사' },
      { e: 'Plumber', k: '배관공' },
      { e: 'Police Officer', k: '경찰관' },
      { e: 'Politician', k: '정치가' },
      { e: 'President', k: '대통령' },
      { e: 'Priest', k: '목사' },
      { e: 'Prison Officer', k: '교도관' },
      { e: 'Professor', k: '교수' },
      { e: 'Researcher', k: '연구원' },
      { e: 'Salesperson', k: '판매원' },
      { e: 'Scholar', k: '학자' },
      { e: 'Scientist', k: '과학자' },
      { e: 'Secretary', k: '비서' },
      { e: 'Singer', k: '가수' },
      { e: 'Soldier', k: '군인' },
      { e: 'Student', k: '학생' },
      { e: 'Surveying Engineer', k: '측량기사' },
      { e: 'Teacher', k: '선생님' },
      { e: 'Translator', k: '번역가' },
      { e: 'Veterinarian', k: '수의사' },
      { e: 'Waiter', k: '웨이터' },
      { e: 'Writer', k: '작가' },
    ],
  },
  animals: {
    name: 'Animals',
    id: 'animals',
    korean: '동물',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Ant', k: '개미' },
      { e: 'Badger', k: '오소리' },
      { e: 'Bat', k: '박쥐' },
      { e: 'Bear', k: '곰' },
      { e: 'Bird', k: '새' },
      { e: 'Buffalo / Bison', k: '새' },
      { e: 'Butterfly', k: '나비' },
      { e: 'Camel', k: '낙타' },
      { e: 'Carp', k: '잉어' },
      { e: 'Cat', k: '고양이' },
      { e: 'Chicken', k: '닭' },
      { e: 'Cicada', k: '매미' },
      { e: 'Cockroach', k: '바퀴벌레' },
      { e: 'Cow', k: '소' },
      { e: 'Crab', k: '게' },
      { e: 'Crocodile', k: '악어' },
      { e: 'Deer', k: '사슴' },
      { e: 'Dog', k: '개' },
      { e: 'Dolphin', k: '돌고래' },
      { e: 'Dragonfly', k: '잠자리' },
      { e: 'Duck', k: '오리' },
      { e: 'Eel', k: '장어' },
      { e: 'Elephant', k: '코끼리' },
      { e: 'Emu', k: '에뮤' },
      { e: 'Fish', k: '물고기' },
      { e: 'Fly', k: '파리' },
      { e: 'Fox', k: '여우' },
      { e: 'Frog', k: '개구리' },
      { e: 'Giraffe', k: '기린' },
      { e: 'Goat', k: '염소' },
      { e: 'Gold Fish', k: '금붕어' },
      { e: 'Goose', k: '거위' },
      { e: 'Hamster', k: '햄스터' },
      { e: 'Hare', k: '산토끼' },
      { e: 'Hawk', k: '매' },
      { e: 'Horse', k: '말' },
      { e: 'Insect', k: '곤충' },
      { e: 'Kangaroo', k: '캥거루' },
      { e: 'Koala', k: '코알라' },
      { e: 'Lion', k: '사자' },
      { e: 'Lizard', k: '도마뱀' },
      { e: 'Mackeral', k: '고등어' },
      { e: 'Monkey', k: '원숭이' },
      { e: 'Mosquito', k: '모기' },
      { e: 'Moth', k: '나방' },
      { e: 'Mouse', k: '생쥐' },
      { e: 'Octopus', k: '문어' },
      { e: 'Ostrich', k: '타조' },
      { e: 'Panda', k: '판다' },
      { e: 'Parrot', k: '앵무새' },
      { e: 'Penguin', k: '펭귄' },
      { e: 'Pheasant', k: '꿩' },
      { e: 'Pig', k: '돼지' },
      { e: 'Pupa', k: '번데기' },
      { e: 'Puppy', k: '강아지' },
      { e: 'Rabbit', k: '토끼' },
      { e: 'Rat', k: '쥐 / 시궁쥐' },
      { e: 'Scorpion', k: '전갈' },
      { e: 'Shark', k: '상어' },
      { e: 'Sheep', k: '양' },
      { e: 'Shrimp', k: '새우' },
      { e: 'Snail', k: '달팽이' },
      { e: 'Snake', k: '뱀' },
      { e: 'Spider', k: '거미' },
      { e: 'Squid', k: '오징어' },
      { e: 'Squirrel', k: '다람쥐' },
      { e: 'Stingray', k: '가오리' },
      { e: 'Tadpole', k: '올챙이' },
      { e: 'Tiger', k: '호랑이' },
      { e: 'Turtle', k: '거북' },
      { e: 'Wasp', k: '말벌' },
      { e: 'Water Buffalo', k: '물소' },
      { e: 'Whale', k: '고래' },
      { e: 'Wolf', k: '늑대' },
      { e: 'Zebra', k: '얼룩말' },
    ],
  },
  colors: {
    name: 'Colors',
    id: 'colors',
    korean: '색깔',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Colour', k: '색깔' },
      { e: 'Red', k: '빨간색' },
      { e: 'Gold', k: '금색' },
      { e: 'Silver', k: '은색' },
      { e: 'Brown', k: '갈색' },
      { e: 'Navy', k: '남색' },
      { e: 'White', k: '하얀색' },
      { e: 'Grey', k: '회색' },
      { e: 'Purple', k: '보라색' },
      { e: 'Orange', k: '주황색' },
      { e: 'Pink', k: '분홍색' },
      { e: 'Black', k: '검은색' },
      { e: 'Blue', k: '파란색' },
      { e: 'Green', k: '초록색' },
      { e: 'Yellow', k: '노란색' },
    ],
  },
  family: {
    name: 'Family',
    id: 'family',
    korean: '가족',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Mum', k: '엄마' },
      { e: 'Mother', k: '어머니' },
      { e: 'Dad', k: '아빠' },
      { e: 'Father', k: '아버지' },
      { e: 'Parents', k: '부모님' },
      { e: 'Adult', k: '어른' },
      { e: 'Baby', k: '아기' },
      { e: 'Child', k: '아이, 어린이' },
      { e: 'Family', k: '가족' },
      { e: 'Cousin', k: '사촌' },
      { e: 'Grandfather', k: '할아버지' },
      { e: 'Grandparents', k: '조부모님' },
      { e: 'Grandmother', k: '할머니' },
      { e: 'Relatives', k: '친척' },
      { e: 'Husband', k: '남편' },
      { e: 'Wife', k: '부인' },
      { e: 'Younger sister', k: '여동생' },
      { e: 'Younger brother', k: '남동생' },
      { e: 'Older brother (as male)', k: '형' },
      { e: 'Older brother (as female)', k: '오빠' },
      { e: 'Older sister (as male)', k: '누나' },
      { e: 'Older sister (as female)', k: '언니' },
    ],
  },
  consonants: {
    name: 'Consonants',
    id: 'consonants',
    korean: '자음',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
      { id: 'n', name: 'Name' },
    ],
    words: [
      { e: 'g / k', k: 'ㄱ', n: '기역' },
      { e: 'kk', k: 'ㄲ', n: '쌍기역' },
      { e: 'n', k: 'ㄴ', n: '니은' },
      { e: 'd', k: 'ㄷ', n: '디귿' },
      { e: 'tt', k: 'ㄸ', n: '쌍디귿' },
      { e: 'r, l', k: 'ㄹ', n: '리을' },
      { e: 'm', k: 'ㅁ', n: '미음' },
      { e: 'b', k: 'ㅂ', n: '비읍' },
      { e: 'pp', k: 'ㅃ', n: '쌍비읍' },
      { e: 's', k: 'ㅅ', n: '시옷' },
      { e: 'ss', k: 'ㅆ', n: '쌍시옷' },
      { e: '-, ng', k: 'ㅇ', n: '이응' },
      { e: 'j', k: 'ㅈ', n: '지읒' },
      { e: 'jj', k: 'ㅉ', n: '쌍지읒' },
      { e: 'ch', k: 'ㅊ', n: '치읓' },
      { e: 'k', k: 'ㅋ', n: '키읔' },
      { e: 't', k: 'ㅌ', n: '티읕' },
      { e: 'p', k: 'ㅍ', n: '피읖' },
      { e: 'h', k: 'ㅎ', n: '히읗' },
    ],
  },
  vowels: {
    name: 'Vowels',
    id: 'vowels',
    korean: '모음',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'a', k: 'ㅏ' },
      { e: 'ae', k: 'ㅐ' },
      { e: 'ya', k: 'ㅑ' },
      { e: 'yae', k: 'ㅒ' },
      { e: 'eo', k: 'ㅓ' },
      { e: 'e', k: 'ㅔ' },
      { e: 'yeo', k: 'ㅕ' },
      { e: 'ye', k: 'ㅖ' },
      { e: 'o', k: 'ㅗ' },
      { e: 'wa', k: 'ㅘ' },
      { e: 'wae', k: 'ㅘ' },
      { e: 'oe', k: 'ㅚ' },
      { e: 'yo', k: 'ㅛ' },
      { e: 'u', k: 'ㅜ' },
      { e: 'wo', k: 'ㅝ' },
      { e: 'we', k: 'ㅞ' },
      { e: 'wi', k: 'ㅟ' },
      { e: 'yu', k: 'ㅠ' },
      { e: 'eu', k: 'ㅡ' },
      { e: 'ui', k: 'ㅢ' },
      { e: 'i', k: 'ㅣ' },
    ],
  },
  parts_of_the_body: {
    name: 'Parts of the Body',
    id: 'parts_of_the_body',
    korean: '몸 부위들',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Body', k: '몸' },
      { e: 'Head', k: '머리' },
      { e: 'Face', k: '얼굴' },
      { e: 'Forehead', k: '이마' },
      { e: 'Eye', k: '눈' },
      { e: 'Eyebrow', k: '눈썹' },
      { e: 'Eyelashes', k: '속눈썹' },
      { e: 'Nose', k: '코' },
      { e: 'Ear', k: '귀' },
      { e: 'Mouth', k: '입' },
      { e: 'Lips', k: '입술' },
      { e: 'Throat', k: '목구멍' },
      { e: 'Tongue', k: '혀' },
      { e: 'Tooth', k: '이' },
      { e: 'Nostrils', k: '콧구멍' },
      { e: 'Neck', k: '목' },
      { e: 'Chin', k: '턱' },
      { e: 'Arm', k: '팔' },
      { e: 'Abdomen', k: '배' },
      { e: 'Chest', k: '가슴' },
      { e: 'Breast', k: '유방' },
      { e: 'Armpit', k: '겨드랑이' },
      { e: 'Thumb', k: '엄지' },
      { e: 'Finger', k: '손바닥' },
      { e: 'Palm', k: '손미닥' },
      { e: 'Elbow', k: '팔꿈치' },
      { e: 'Wrist', k: '팔목' },
      { e: 'Hand', k: '손' },
      { e: 'Shoulder', k: '어깨' },
      { e: 'Fingernail', k: '손톱' },
      { e: 'Waist', k: '허리' },
      { e: 'Butt', k: '엉덩이' },
      { e: 'Thigh', k: '허벅지' },
      { e: 'Knee', k: '무릎' },
      { e: 'Ankle', k: '발목' },
      { e: 'Foot', k: '발' },
      { e: 'Heel', k: '뒤꿈치' },
      { e: 'Toenail', k: '발톱' },
      { e: 'Muscle', k: '근육' },
      { e: 'Bone', k: '뼈' },
      { e: 'Skin', k: '살갗' },
      { e: 'Lungs', k: '허파' },
      { e: 'Hair', k: '머리카락' },
      { e: 'Brain', k: '뇌' },
      { e: 'Skull', k: '머리뼈' },
      { e: 'Spine', k: '척주' },
      { e: 'Heart', k: '심장' },
    ],
  },
  drinks: {
    name: 'Drinks',
    id: 'drinks',
    korean: '음료',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Water', k: '물' },
      { e: 'Juice', k: '주스' },
      { e: 'Smoothie', k: '스무디' },
      { e: 'Soda', k: '소다' },
      { e: 'Shake', k: '쉐이크' },
      { e: 'Milk', k: '우유' },
      { e: 'Soy Milk', k: '두유' },
      { e: 'Oat Milk', k: '오트밀크' },
      { e: 'Almond Milk', k: '아몬드밀크' },
      { e: 'Rice Milk', k: '라이스밀크' },
      { e: 'Coconut Milk', k: '코코넛 밀크' },
      { e: 'Coconut Water', k: '코코넛 워터' },
      { e: 'Tea', k: '차' },
      { e: 'Green Tea', k: '녹차' },
      { e: 'Coffee', k: '커피' },
      { e: 'Latte', k: '라떼' },
      { e: 'Cappuccino', k: '카푸치노' },
      { e: 'Espresso', k: '에스프레소' },
      { e: 'Frappe', k: '프라페' },
      { e: 'Frappuccino', k: '프라푸치노' },
      { e: 'Alcohol', k: '술' },
      { e: 'Soju', k: '소주' },
      { e: 'Beer', k: '맥주' },
      { e: 'Wine', k: '와인' },
      { e: 'Champagne ', k: '샴페인' },
      { e: 'Cider', k: '사과주' },
      { e: 'Cocktail', k: '칵테일' },
      { e: 'Shot', k: '샷' },
    ],
  },
  shapes: {
    name: 'Shapes',
    id: 'shapes',
    korean: '모양들',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Square', k: '네모' },
      { e: 'Rectangle', k: '직사각형' },
      { e: 'Circle', k: '원' },
      { e: 'Oval', k: '타원' },
      { e: 'Triangle', k: '삼각형, 세모' },
      { e: 'Line', k: '선' },
      { e: 'Straight line', k: '직선' },
      { e: 'Pentagon', k: '오각형' },
      { e: 'Hexagon', k: '육각형' },
      { e: 'Heptagon', k: '칠각형' },
      { e: 'Octagon', k: '팔각형' },
      { e: 'Polygon', k: '다각형' },
      { e: 'Crescent', k: '초승달' },
    ],
  },
  technology: {
    name: 'Technology',
    id: 'technology',
    korean: '기술',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Technology', k: '기술' },
      { e: 'Computer', k: '컴퓨터' },
      { e: 'Phone', k: '전화기' },
      { e: 'Mobile phone', k: '휴대폰' },
      { e: 'iPhone', k: '아이폰' },
      { e: 'Internet', k: '인터넷' },
      { e: 'Internet cafe', k: '인터넷 카페' },
      { e: 'Wi-Fi', k: '와이파이' },
      { e: 'Website', k: '웹사이트' },
      { e: 'Email', k: '이메일' },
      { e: 'Text message', k: '문자' },
      { e: 'Laptop', k: '노트북' },
      { e: 'Keyboard', k: '키보드' },
      { e: 'Microphone', k: '마이크' },
      { e: 'Headphones', k: '헤드폰' },
      { e: 'Speaker', k: '스피커' },
      { e: 'Camera', k: '카메라' },
      { e: 'App', k: '앱' },
      { e: 'Robot', k: '로봇' },
      { e: 'Software', k: '소프트웨어' },
      { e: 'Hardware', k: '하드웨어' },
      { e: 'Screen', k: '화면' },
      { e: 'Resolution', k: '해상도' },
      { e: 'Battery', k: '배터리' },
      { e: 'Cable', k: '케이블' },
      { e: 'Password', k: '비밀번호' },
      { e: 'Click', k: '클릭' },
      { e: 'Code', k: '번호' },
      { e: 'Device', k: '장치' },
    ],
  },
  emotions: {
    name: 'Emotions',
    id: 'emotions',
    korean: '감정',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Feeling', k: '느낌' },
      { e: 'Emotion', k: '감정' },
      { e: 'Happy', k: '행복한' },
      { e: 'Unhappy', k: '불행한' },
      { e: 'Sad', k: '슬픈' },
      { e: 'Sadness', k: '슬픔' },
      { e: 'Tired', k: '피곤한' },
      { e: 'Anger', k: '화' },
      { e: 'Angry', k: '화난' },
      { e: 'Shy', k: '부끄러운' },
      { e: 'Excited', k: '흥미진진한' },
      { e: 'Love', k: '사랑' },
      { e: 'Fear', k: '두려움' },
      { e: 'Regret', k: '후회' },
      { e: 'Jealousy', k: '질투' },
      { e: 'Excitement', k: '흥분' },
      { e: 'Disappointment', k: '실망' },
      { e: 'Mood', k: '분위기' },
      { e: 'Frustration', k: '불만' },
      { e: 'Grief', k: '비탄' },
      { e: 'Confusion', k: '혼선' },
      { e: 'Fury', k: '분노' },
      { e: 'Joy', k: '즐거움' },
      { e: 'Worry', k: '걱정' },
      { e: 'Hatred', k: '증오' },
      { e: 'Panic', k: '공황' },
      { e: 'Pleasure', k: '기쁨' },
      { e: 'Lonely', k: '외로운' },
    ],
  },
  airport: {
    name: 'Airport',
    id: 'airport',
    korean: '공항',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      { e: 'Airport', k: '공항' },
      { e: 'Airplane', k: '항공기' },
      { e: 'Airport immigration office', k: '출입국관리소' },
      { e: 'Passenger terminal', k: '여객터미널' },
      { e: 'Control tower', k: '관제탑' },
      { e: 'Duty free shop', k: '면세점' },
      { e: 'Currency exchange', k: '환전소' },
      { e: 'Gate', k: '게이트' },
      { e: 'Lounge', k: '라운지' },
      { e: 'Domestic air travel', k: '국내선' },
      { e: 'International  air travel', k: '국제선' },
      { e: 'International  air travel', k: '국제선' },
      { e: 'Aviation', k: '항공' },
      { e: 'Departure', k: '출발' },
      { e: 'Arrival', k: '도착' },
      { e: 'Delay', k: '지연' },
      { e: 'Route', k: '노선' },
      { e: 'Baggage', k: '수하물' },
      { e: 'Boarding pass', k: '탑승권' },
      { e: 'Airline ticket', k: '항공권' },
      { e: 'Passport', k: '여권' },
      { e: 'Visa', k: '비자' },
      { e: 'Passenger', k: '탑승객' },
      { e: 'Departing from a country', k: '출국' },
      { e: 'Entering a country', k: '입국' },
      { e: 'Boarding', k: '탑승' },
      { e: 'Transfer', k: '환승' },
      { e: 'One-way', k: '편도' },
      { e: 'Round trip', k: '왕복' },
      { e: 'Customs official', k: '세관원' },
      { e: 'Customs duties', k: '관세' },
    ],
  },
  bathroom: {
    name: 'Bathroom',
    id: 'bathroom',
    korean: '욕실',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      {
        k: '욕실',
        e: 'bathroom',
      },
      {
        k: '싱크대',
        e: 'sink',
      },
      {
        k: '변기',
        e: 'toilet',
      },
      {
        k: '치약',
        e: 'toothpaste',
      },
      {
        k: '칫솔',
        e: 'toothbrush',
      },
      {
        k: '샴푸',
        e: 'shampoo',
      },
      {
        k: '비누',
        e: 'soap',
      },
      {
        k: '수건',
        e: 'towel',
      },
      {
        k: '화장지',
        e: 'toilet paper',
      },
      {
        k: '드라이기',
        e: 'hairdryer',
      },
      {
        k: '빗',
        e: 'comb',
      },
      {
        k: '거울',
        e: 'mirror',
      },
      {
        k: '샤워',
        e: 'shower',
      },
      {
        k: '목욕통',
        e: 'bathtub',
      },
      {
        k: '구강청결제',
        e: 'mouthwash',
      },
      {
        k: '치실',
        e: 'floss',
      },
      {
        k: '비누거품',
        e: 'soap bubble',
      },
      {
        k: '샤워가운',
        e: 'bathrobe',
      },
      {
        k: '변기솔',
        e: 'toilet brush',
      },
      {
        k: '면도기',
        e: 'razor',
      },
      {
        k: '면도날',
        e: 'razor blade',
      },
      {
        k: '위생',
        e: 'hygiene',
      },
      {
        k: '대걸레',
        e: 'mop',
      },
      {
        k: '양동이',
        e: 'bucket',
      },
    ],
  },
  kitchen: {
    name: 'Kitchen',
    id: 'kitchen',
    korean: '부엌',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      {
        k: '부엌',
        e: 'kitchen',
      },
      {
        k: '오븐',
        e: 'oven',
      },
      {
        k: '냉장고',
        e: 'refrigerator',
      },
      {
        k: '가스레인지',
        e: 'stove',
      },
      {
        k: '전자레인지',
        e: 'microwave oven',
      },
      {
        k: '식기세척기',
        e: 'dishwasher',
      },
      {
        k: '커피머신',
        e: 'coffee machine',
      },
      {
        k: '주전자',
        e: 'kettle',
      },
      {
        k: '컵',
        e: 'glass',
      },
      {
        k: '냄비',
        e: 'pot',
      },
      {
        k: '후라이팬',
        e: 'pan',
      },
      {
        k: '물병',
        e: 'jug',
      },
      {
        k: '앞치마',
        e: 'apron',
      },
      {
        k: '티스푼',
        e: 'teaspoon',
      },
      {
        k: '수저세트',
        e: 'cutlery',
      },
      {
        k: '포크',
        e: 'fork',
      },
      {
        k: '숟가락',
        e: 'spoon',
      },
      {
        k: '칼',
        e: 'knife',
      },
      {
        k: '젓가락',
        e: 'chopstick',
      },
      {
        k: '접시',
        e: 'plate',
      },
      {
        k: '냉동실',
        e: 'freezer',
      },
      {
        k: '토스터기',
        e: 'toaster',
      },
      {
        k: '찬장',
        e: 'kitchen cabinet',
      },
      {
        k: '행주',
        e: 'dish cloth',
      },
      {
        k: '주방 세제',
        e: 'dishwashing liquid',
      },
      {
        k: '스폰지',
        e: 'sponge',
      },
      {
        k: '수도꼭지',
        e: 'tap',
      },
      {
        k: '싱크대',
        e: 'sink',
      },
      {
        k: '강판',
        e: 'grater',
      },
      {
        k: '거품기',
        e: 'whisk',
      },
      {
        k: '소금 뿌리개',
        e: 'salt shaker',
      },
      {
        k: '체',
        e: 'sieve',
      },
      {
        k: '밀방망이',
        e: 'rolling pin',
      },
      {
        k: '그릇',
        e: 'bowl',
      },
      {
        k: '베이킹 트레이',
        e: 'baking tray',
      },
      {
        k: '빨대',
        e: 'drinking straw',
      },
      {
        k: '병따개',
        e: 'can opener',
      },
      {
        k: '받침',
        e: 'saucer',
      },
      {
        k: '깔때기',
        e: 'funnel',
      },
      {
        k: '오븐용 장갑',
        e: 'oven mitt',
      },
      {
        k: '식탁보',
        e: 'tablecloth',
      },
      {
        k: '냅킨',
        e: 'napkin',
      },
      {
        k: '종이 타월',
        e: 'paper towel',
      },
    ],
  },
  law_and_crime: {
    name: 'Law and Crime ',
    id: 'law_and_crime',
    korean: '법와 범죄',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      {
        k: '법정',
        e: 'court',
      },
      {
        k: '법',
        e: 'law',
      },
      {
        k: '범죄',
        e: 'crime',
      },
      {
        k: '재소자',
        e: 'prisoner',
      },
      {
        k: '도둑',
        e: 'thief',
      },
      {
        k: '지문',
        e: 'fingerprint',
      },
      {
        k: '소송',
        e: 'lawsuit',
      },
      {
        k: '체험판',
        e: 'trial',
      },
      {
        k: '경찰관',
        e: 'policeman',
      },
      {
        k: '수갑',
        e: 'handcuffs',
      },
      {
        k: '변호사',
        e: 'lawyer',
      },
      {
        k: '판사',
        e: 'judge',
      },
      {
        k: '정의',
        e: 'justice',
      },
      {
        k: '피해자',
        e: 'victim',
      },
      {
        k: '증인',
        e: 'witness',
      },
      {
        k: '폭력',
        e: 'violence',
      },
      {
        k: '의심',
        e: 'suspect',
      },
      {
        k: '반대',
        e: 'objection',
      },
      {
        k: '인질',
        e: 'hostage',
      },
      {
        k: '인종차별',
        e: 'racism',
      },
      {
        k: '남용',
        e: 'abuse',
      },
      {
        k: '사기',
        e: 'fraud',
      },
      {
        k: '살인',
        e: 'murder',
      },
      {
        k: '불평',
        e: 'complaint',
      },
      {
        k: '처벌',
        e: 'punishment',
      },
      {
        k: '헌법',
        e: 'constitution',
      },
      {
        k: '결백',
        e: 'innocence',
      },
      {
        k: '경찰',
        e: 'police',
      },
      {
        k: '증거',
        e: 'evidence',
      },
      {
        k: '테러',
        e: 'terrorism',
      },
      {
        k: '모욕',
        e: 'insult',
      },
      {
        k: '조직폭력단',
        e: 'mob',
      },
      {
        k: '판결',
        e: 'verdict',
      },
      {
        k: '배심원',
        e: 'jury',
      },
      {
        k: '살인자',
        e: 'murderer',
      },
      {
        k: '자객',
        e: 'assassin',
      },
      {
        k: '테러리스트',
        e: 'terrorist',
      },
      {
        k: '인권',
        e: 'human rights',
      },
      {
        k: '진술',
        e: 'statement',
      },
      {
        k: '순찰대',
        e: 'patrol',
      },
      {
        k: '작전',
        e: 'operation',
      },
    ],
  },
  music: {
    name: 'Music',
    id: 'music',
    korean: '음악',
    columns: [
      { id: 'e', name: 'English' },
      { id: 'k', name: 'Korean' },
    ],
    words: [
      {
        k: '음악',
        e: 'music',
      },
      {
        k: '마이크',
        e: 'microphone',
      },
      {
        k: '헤드폰',
        e: 'headphones',
      },
      {
        k: '스피커',
        e: 'speaker',
      },
      {
        k: '무대',
        e: 'stage',
      },
      {
        k: '녹음',
        e: 'recording',
      },
      {
        k: '악기',
        e: 'instrument',
      },
      {
        k: '기타',
        e: 'guitar',
      },
      {
        k: '플루트',
        e: 'flute',
      },
      {
        k: '바이올린',
        e: 'violin',
      },
      {
        k: '피아노',
        e: 'piano',
      },
      {
        k: '드럼',
        e: 'drum',
      },
      {
        k: '가수',
        e: 'singer',
      },
      {
        k: '작곡가',
        e: 'composer',
      },
      {
        k: '음악밴드',
        e: 'music band',
      },
      {
        k: '앨범',
        e: 'album',
      },
      {
        k: '노래',
        e: 'song',
      },
      {
        k: '가사',
        e: 'lyrics',
      },
      {
        k: '선율',
        e: 'melody',
      },
      {
        k: '리듬',
        e: 'rhythm',
      },
      {
        k: '콘서트',
        e: 'concert',
      },
      {
        k: '합창단',
        e: 'choir',
      },
      {
        k: '관현악단',
        e: 'orchestra',
      },
      {
        k: '드러머',
        e: 'drummer',
      },
      {
        k: '발레',
        e: 'ballet',
      },
      {
        k: '오페라',
        e: 'opera',
      },
      {
        k: '뮤지컬',
        e: 'musical',
      },
      {
        k: '재즈',
        e: 'jazz',
      },
      {
        k: '교향곡',
        e: 'symphony',
      },
      {
        k: '하프',
        e: 'harp',
      },
      {
        k: '이중주',
        e: 'duet',
      },
    ],
  },
};

/*
countries: {
  name: 'Countries',
  id: 'countries',
  korean: '나라',
  columns: [
    { id: 'e', name: 'English' },
    { id: 'k', name: 'Korean' },
  ],
  words: [{ e: 'Airplane', k: '비행기' }]
}, */
